import BaseModel from '@core/model';

export class InvestmentStrategy extends BaseModel {
    static entity = 'investmentStrategies';

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default InvestmentStrategy;
